export default __webpack_public_path__ + "static/KeywordResearch_02_01-670d4c640fd722b6c899e88d8e634005.webp";